export default function LoadingScreen() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-transparent">
      <div className="animate-fade-in text-center">
        <div className="mx-auto mb-5 flex h-12 w-12 animate-pulse items-center justify-center rounded-2xl bg-primary-600 shadow-xs">
          <span className="text-xl font-semibold text-primary-900">S</span>
        </div>
        <div className="space-y-2">
          <div className="skeleton mx-auto h-3 w-28 rounded-full" />
          <div className="skeleton mx-auto h-2.5 w-20 rounded-full" />
        </div>
      </div>
    </div>
  );
}
